import { lazy, Suspense, type FC, type ReactNode } from 'react';
import { graphql, createFragmentContainer } from 'react-relay/legacy.js';

// types
import { type BuyerChatRespLazy_viewer$data as Viewer } from './__generated__/BuyerChatRespLazy_viewer.graphql.ts';

const LazyComponent = lazy(
    () => import(/* webpackChunkName: "BuyerChatResp" */ './BuyerChatResp.tsx')
);

type Props = {
    viewer: Viewer;
    currency: string;
    isInitiallyMinimized: boolean;
    draftedMessage?: string | null;
    onOpenMakeOfferModal?: () => void;
    onCloseMakeOfferModal?: () => void;
    showSellerBranding?: boolean;
    infoBanner?: ReactNode;
};

export const BuyerChatRespLazyComponent: FC<Props> = props =>
    props.viewer ? (
        <Suspense fallback="">
            <LazyComponent {...props} />
        </Suspense>
    ) : null;

export const BuyerChatRespLazy = createFragmentContainer(BuyerChatRespLazyComponent, {
    viewer: graphql`
        fragment BuyerChatRespLazy_viewer on Viewer {
            ...BuyerChatResp_viewer
        }
    `,
});
